var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"NewsArticle"},[_c('h3',{staticClass:"text-h5 py-4 font-weight-bold"},[_vm._t("title")],2),_c('p',{staticClass:"text-caption py-0"},[_vm._v(_vm._s(_vm.formattedDate))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }